import { waitFor } from 'wait-ready';
import { browser } from '../browser';
import { EncryptMethodEnum } from '../config';
import { logger } from '../logger';
export * from './common';
export * from './react-native-permissions';
const logCategory = 'interface:webviewrpc';
const rpcReady = browser.isSHMApp()
    ? waitFor(() => { var _a; return ((_a = window.ReactNativeWebView) === null || _a === void 0 ? void 0 : _a.postMessage) && window.SHMRPC; }, {
        timeout: 10000,
        checkInterval: 200,
    }).catch((err) => {
        logger.error('failed to init rpc on app', logCategory, {
            app_version: browser.getSHMAppVersion(),
            binary_version: browser.getSHMAppBinaryVersion(),
        });
        throw err;
    })
    : Promise.resolve(null);
const comlinkProxy = {
    getCommonInfoV2: () => {
        return rpcReady.then((shmrpc) => shmrpc.getCommonInfoV2());
    },
    addEventListener: (type, listener) => {
        return rpcReady.then((shmrpc) => shmrpc.addEventListener(type, listener));
    },
    removeEventListener: (key) => {
        return rpcReady.then((shmrpc) => shmrpc.removeEventListener(key));
    },
    getAbTestParam: (keys) => {
        return rpcReady.then((shmrpc) => shmrpc.getAbTestParam(keys));
    },
    receiveReportEvents: (events, commonParams) => {
        return rpcReady.then((shmrpc) => shmrpc.receiveReportEvents(events, commonParams));
    },
    dispatchAction: (action) => {
        return rpcReady.then((shmrpc) => shmrpc.dispatchAction(action));
    },
    dispatchWebEvent: (event) => {
        return rpcReady.then((shmrpc) => shmrpc.dispatchWebEvent(event));
    },
    checkAppUpdate: () => {
        return rpcReady.then((shmrpc) => shmrpc.checkAppUpdate());
    },
    setTitle: (title) => {
        return rpcReady.then((shmrpc) => shmrpc.setTitle(title));
    },
    setStatusBar: (style, background) => {
        return rpcReady.then((shmrpc) => shmrpc.setStatusBar(style, background));
    },
    setNavigationBarVisible: (visible) => {
        return rpcReady.then((shmrpc) => shmrpc.setNavigationBarVisible(visible));
    },
    onShare: (data) => {
        return rpcReady.then((shmrpc) => shmrpc.onShare(data));
    },
    shareToWechat: (options) => {
        return rpcReady.then((shmrpc) => shmrpc.shareToWechat(options));
    },
    openWechatMiniprogram: (options) => {
        return rpcReady.then((shmrpc) => shmrpc.openWechatMiniprogram(options));
    },
    canOpenURL: (url) => {
        return rpcReady.then((shmrpc) => shmrpc.canOpenURL(url));
    },
    onClose: (callback) => {
        return rpcReady.then((shmrpc) => shmrpc.onClose(callback));
    },
    openURL: (url) => {
        return rpcReady.then((shmrpc) => shmrpc.openURL(url));
    },
    navigateClose: () => {
        return rpcReady.then((shmrpc) => shmrpc.navigateClose());
    },
    navigateTo: (url) => {
        return rpcReady.then((shmrpc) => shmrpc.navigateTo(url));
    },
    clipBoardGetString: () => {
        return rpcReady.then((shmrpc) => shmrpc.clipBoardGetString());
    },
    clipBoardSetString: (string) => {
        return rpcReady.then((shmrpc) => shmrpc.clipBoardSetString(string));
    },
    checkNotifications: () => {
        return rpcReady.then((shmrpc) => shmrpc.checkNotifications());
    },
    requestNotifications: (options) => {
        return rpcReady.then((shmrpc) => shmrpc.requestNotifications(options));
    },
    openSystemSettingPage: () => {
        return rpcReady.then((shmrpc) => shmrpc.openSystemSettingPage());
    },
    requestAppStoreReview: () => {
        return rpcReady.then((shmrpc) => shmrpc.requestAppStoreReview());
    },
    bindTaoBao: (options) => {
        return rpcReady.then((shmrpc) => shmrpc.bindTaoBao(options));
    },
    savePhotoToAlbum: (url) => {
        return rpcReady.then((shmrpc) => shmrpc.savePhotoToAlbum(url));
    },
    watchAd: (position, options, onLoad) => {
        return rpcReady.then((shmrpc) => shmrpc.watchAd(position, options, onLoad));
    },
    preloadVideoAds: (positions) => {
        return rpcReady.then((shmrpc) => shmrpc.preloadVideoAds(positions));
    },
    pay: (orderId, options) => {
        return rpcReady.then((shmrpc) => shmrpc.pay(orderId, options));
    },
    getCurrentLocation: () => {
        return rpcReady.then((shmrpc) => shmrpc.getCurrentLocation());
    },
    requestPermission: (permission, options) => {
        return rpcReady.then((shmrpc) => shmrpc.requestPermission(permission, options));
    },
    requestPermissions: (permission, options) => {
        return rpcReady.then((shmrpc) => shmrpc.requestPermissions(permission, options));
    },
    checkPermission: (permission) => {
        return rpcReady.then((shmrpc) => shmrpc.checkPermission(permission));
    },
    encrypt: (plainText) => {
        return rpcReady.then((shmrpc) => shmrpc.encrypt(plainText));
    },
    decrypt: (encrypted) => {
        return rpcReady.then((shmrpc) => shmrpc.decrypt(encrypted));
    },
    apiCacheGet: (key) => {
        return rpcReady.then((shmrpc) => shmrpc.apiCacheGet(key));
    },
    apiCacheSet: (key, value) => {
        return rpcReady.then((shmrpc) => shmrpc.apiCacheSet(key, value));
    },
    apiCacheRemove: (key) => {
        return rpcReady.then((shmrpc) => shmrpc.apiCacheRemove(key));
    },
    apiCacheGetKeys: () => {
        return rpcReady.then((shmrpc) => shmrpc.apiCacheGetKeys());
    },
    apiCacheClear: () => {
        return rpcReady.then((shmrpc) => shmrpc.apiCacheClear());
    },
};
// for handle events
// keep all keys for clean up
const listenerKeys = new Set();
// try to cleanup listener keys on unload
window.onbeforeunload = () => {
    // don't need to wait here as it must be ready to have keys set
    listenerKeys.forEach((key) => comlinkProxy.removeEventListener(key));
};
const listenerRecordSetByEventType = new Map();
const findEventListenerKey = (event, listener, removeOnFound = false) => {
    if (!listenerRecordSetByEventType.has(event)) {
        return '';
    }
    const listenerRecord = Array.from(listenerRecordSetByEventType.get(event)).find((item) => item.listener === listener);
    if (!listenerRecord) {
        return '';
    }
    const { key } = listenerRecord;
    if (removeOnFound) {
        listenerRecordSetByEventType.get(event).delete(listenerRecord);
        listenerKeys.delete(key);
    }
    return key;
};
// override the default behavior
const overrides = {
    addEventListener(type, listener) {
        const previousKey = findEventListenerKey(type, listener);
        if (previousKey) {
            return Promise.resolve(previousKey);
        }
        return comlinkProxy.addEventListener(type, listener).then((key) => {
            if (!listenerRecordSetByEventType.has(type)) {
                listenerRecordSetByEventType.set(type, new Set());
            }
            listenerRecordSetByEventType.get(type).add({ key, listener });
            listenerKeys.add(key);
            return key;
        });
    },
    removeEventListener(typeOrKey, listener) {
        let key;
        if (listenerKeys.has(typeOrKey)) {
            key = typeOrKey;
            listenerKeys.delete(key);
            Array.from(listenerRecordSetByEventType.values()).some((listenerRecordSet) => {
                const record = Array.from(listenerRecordSet).find((item) => item.key === key);
                if (!record) {
                    return false;
                }
                listenerRecordSet.delete(record);
                return true;
            });
        }
        else if (listener) {
            key = findEventListenerKey(typeOrKey, listener, true);
        }
        if (!key) {
            return Promise.resolve(true);
        }
        return comlinkProxy.removeEventListener(key);
    },
};
export const rpc = Object.assign(Object.assign({}, comlinkProxy), overrides);
class RPCAPICache {
    get(key) {
        return rpc.apiCacheGet(key);
    }
    set(key, value) {
        return rpc.apiCacheSet(key, value);
    }
    remove(key) {
        return rpc.apiCacheRemove(key);
    }
    getKeys() {
        return rpc.apiCacheGetKeys();
    }
    clear() {
        return rpc.apiCacheClear();
    }
}
/**
 * api cache proxy through webview rpc
 * @version 16.1.0
 */
export const rpcCache = new RPCAPICache();
/**
 * crypter through webview rpc
 */
export const rpcCrypter = {
    method: EncryptMethodEnum.INNO_SECURE,
    encrypt: (plainText) => rpc.encrypt(plainText),
    decrypt: (encrypted) => rpc.decrypt(encrypted),
};
class SHMWebViewRPCCollector {
    receive(events, commonParams) {
        return rpc.receiveReportEvents(events, commonParams);
    }
}
/**
 * report collector through webview rpc
 */
export const rpcCollector = new SHMWebViewRPCCollector();
